import { IFinalProductProps } from "@/interfaces/products";

export const isProductNotToBeListed = (productId: string | undefined, notListedProducts: NotListedProductsProps) => {
    return productId && notListedProducts.productsId.includes(productId);
}

export const getPublicAndPrivateProducts = (products: IFinalProductProps[], notListedProducts: NotListedProductsProps) => {
    let publicProducts: IFinalProductProps[] = []
    let privateProducts: IFinalProductProps[] = [];

    products.forEach( product => {
        if(notListedProducts && notListedProducts.productsId.includes(product.id!)){
            privateProducts.push(product);
        }else{
            publicProducts.push(product);
        }
    });

    return {publicProducts, privateProducts};
}

interface NotListedProductsProps{
    productsId: string[];
}